.contentBox {
  border: 1px solid var(--pm-grey8);
  border-radius: 4px;
  padding: 18px;
  margin-bottom: 16px;
  .innerBox {
    margin-left: -18px;
    margin-right: -18px;
    margin-bottom: -26px;
    padding: 18px;
    border-top: 1px solid var(--pm-grey8);
    margin-top: 18px;
  }
}
:global(.dark) {
  .contentBox {
    border: 1px solid var(--pm-grey3);
  }
}
